class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
    this.summaryElements = this.querySelectorAll('[data-facets-summary]');
    this.applyFiltersButtons = this.querySelectorAll('[data-apply-filters]');
    this.filterGroups = this.querySelectorAll('[data-filter-group]');

    this.debouncedOnSubmit = window.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetsWrapper = this.querySelector('[data-facets-wrapper]');

    if (facetsWrapper) facetsWrapper.addEventListener('keyup', window.onKeyUpEscape);

    if (this.checkboxes.length) {
      this.checkboxes.forEach((checkbox) =>{
        checkbox.addEventListener('keydown', this.clickCheckbox.bind(this));
      });
    }

    if (this.summaryElements.length) {
      this.summaryElements.forEach((summaryElement) => {
        summaryElement.addEventListener('click', this.closeDetails.bind(this));
      });
    }

    if (this.applyFiltersButtons.length) {
      this.applyFiltersButtons.forEach((applyFiltersButton) => {
        applyFiltersButton.addEventListener('click', this.applyFilters.bind(this));
      });
    }

    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() !== 'TAB') { return; }
      this.toggleFilterGroups();
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainers = document.querySelectorAll('[data-product-count]');

    document.querySelector('[data-product-grid-container]').querySelector('[data-product-grid]').classList.add('loading');

    if (countContainers.length) {
      countContainers.forEach((countContainer) => {
        countContainer.classList.add('loading');
      });
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.querySelector('[data-product-grid-container]').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-grid-container]').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-count]').innerHTML;
    const containers = document.querySelectorAll('[data-product-count]');
    const containerDesktop = document.querySelector('[data-product-count-desktop]');

    containers.forEach((container) =>{
      container.innerHTML = count;
      container.classList.remove('loading');
    });

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements =
      parsedHTML.querySelectorAll('[data-facet-filters-form] [data-filter-group], [data-facet-filters-form-mobile] [data-filter-group], [data-facet-filters-pills-form] [data-filter-group]');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('[data-filter-group]') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`[data-filter-group][data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('[data-filter-group]'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['[data-active-facets-mobile]', '[data-active-facets-desktop]'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['[data-filter-drawer-open]', '[data-filter-drawer-count]', '[data-sorting]'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.querySelector('[data-facet-filters-form-mobile]').closest('filter-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');
    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('[data-facets-selected]').outerHTML = source.querySelector('[data-facets-selected]').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('[data-facets-summary]').outerHTML = source.querySelector('[data-facets-summary]').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[data-product-grid]').dataset.id,
      }
    ];
  }

  applyFilters(event) {
    const summary = event.target.closest('[data-filter-drawer-wrapper]').querySelector('summary');

    if (!summary) { return; }

    summary.click();
  }

  clickCheckbox(event) {
    if (event.keyCode !== 13) { return; }

    event.target.click();
  }

  closeDetails(event) {
    this.summaryElements.forEach((element) => {
      if (element === event.target) { return; }

      element.closest('details').removeAttribute('open');
    });
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.hasAttribute == 'data-filter-drawer-checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').hasAttribute('data-facet-filters-form-mobile');

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.hasAttribute('data-facet-sort-form') || form.hasAttribute('data-facet-filters-form') || form.hasAttribute('data-facet-sort-drawer-form')) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.hasAttribute('data-facet-filters-form-mobile')) {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  toggleFilterGroups() {
    this.filterGroups.forEach((filterGroup) => {
      if (!filterGroup.hasAttribute('open')) { return; }

      const activeElementFilterGroup = document.activeElement.closest('[data-filter-group]');

      if (activeElementFilterGroup) {
        if (activeElementFilterGroup != filterGroup) {
          filterGroup.removeAttribute('open');
        }
      } else {
        filterGroup.removeAttribute('open');
      }
    });
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    button.addEventListener('click', (event) => {
      this.expandShowMore(event);

      const nextElementToFocus = event.target.closest('[data-show-more-parent]').querySelector('[data-show-more-item]');

      if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden')) {
        nextElementToFocus.querySelector('input').focus();
      }
    });
  }

  expandShowMore(event) {
    const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('[data-show-more-parent]');

    this.querySelectorAll('[data-show-more-label]').forEach(element => element.classList.toggle('d-none'));

    parentDisplay.querySelectorAll('[data-show-more-item]').forEach(item => item.classList.toggle('d-none'));
  }
}

customElements.define('show-more-button', ShowMoreButton);

class FilterDrawer extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('[data-filter-drawer-close]');
    this.mainDetailsToggle = this.querySelector('details');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        if (window.innerWidth >= 1025) {
          document.body.classList.remove('overflow-hidden');
        } else {
          window.removeScrollLock();
        }
      });
    }

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');

    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeFilterDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      window.trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeFilterDrawer(event, summaryElement) : this.openFilterDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('filter-drawer-open');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openFilterDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('filter-drawer-open');
    });

    summaryElement.setAttribute('aria-expanded', true);

    setTimeout(() => {
      window.trapFocus(this.mainDetailsToggle, summaryElement);
    }, 100);

    if (window.innerWidth >= 1025) {
      document.body.classList.add('overflow-hidden');
    } else {
      window.scrollLock();
    }
  }

  closeFilterDrawer(event, elementToFocus = false) {
    if (event === undefined) { return; }

    this.mainDetailsToggle.classList.remove('filter-drawer-open');

    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');

      details.classList.remove('filter-drawer-open');
    });

    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });

    if (window.innerWidth >= 1025) {
      document.body.classList.remove('overflow-hidden');
    } else {
      window.removeScrollLock();
    }

    window.removeTrapFocus(elementToFocus);

    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeFilterDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');

    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');

    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('filter-drawer-open');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    window.removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');

        if (detailsElement.closest('details[open]')) {
          window.trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('filter-drawer', FilterDrawer);